import { Badge, BadgeVariant } from '@moment/design-system-ui/badge'

interface AssetTypeBadgeProps {
  label: string
  className?: string
}

export function AssetTypeBadge({ label, className = '' }: AssetTypeBadgeProps) {
  return (
    <Badge className={className} variant={BadgeVariant.Neutral}>
      {label}
    </Badge>
  )
}
